import { TransactionStatus } from "@shared_packages/toolkit/types";
import {
  ISearchFieldConfig,
  SearchFieldType,
} from "../../../../../components/advanced-search/AdvancedSearch.interface";
import { currencyConfig } from "../../../../../constants/currencies";

export const OBtransactionsSearchConfig: ISearchFieldConfig[] = [
  {
    type: SearchFieldType.AMOUNT_RANGE,
    label: "Amount",
    key: "amountFrom",
    rangeEndKey: "amountTo",
    placeholder: "From",
    rangeEndPlaceholder: "To",
  },
  {
    type: SearchFieldType.DATE_RANGE,
    label: "Created date",
    key: "from",
    rangeEndKey: "to",
    placeholder: "From",
    rangeEndPlaceholder: "To",
  },
  {
    type: SearchFieldType.DATE_RANGE,
    label: "Completed date",
    key: "completedFrom",
    rangeEndKey: "completedTo",
    placeholder: "From",
    rangeEndPlaceholder: "To",
  },
  {
    type: SearchFieldType.TEXT,
    label: "Reference",
    key: "reference",
    placeholder: "Payment reference",
  },
  {
    type: SearchFieldType.TEXT,
    label: "Payment ID",
    key: "parentEntity",
    placeholder: "Payment ID",
  },
  { ...currencyConfig },
  {
    type: SearchFieldType.DROPDOWN,
    label: "Status",
    key: "status",
    dropdownValues: [
      {
        label: "All",
        value: "",
      },
      {
        label: "Aborted",
        value: TransactionStatus.ABORTED,
      },
      {
        label: "Cancelled",
        value: TransactionStatus.CANCELLED,
      },
      {
        label: "Completed",
        value: TransactionStatus.COMPLETED,
      },
      {
        label: "Created",
        value: TransactionStatus.CREATED,
      },
      {
        label: "In progress",
        value: TransactionStatus.IN_PROGRESS,
      },
      {
        label: "Missed",
        value: TransactionStatus.MISSED,
      },
      {
        label: "Partially paid",
        value: TransactionStatus.PARTIALLY_PAID,
      },
      {
        label: "Pending",
        value: TransactionStatus.PENDING,
      },
      {
        label: "Rejected",
        value: TransactionStatus.REJECTED,
      },
      {
        label: "Started",
        value: TransactionStatus.STARTED,
      },
      {
        label: "Unable to check",
        value: TransactionStatus.UNABLE_TO_CHECK,
      },
    ],
  },
  {
    type: SearchFieldType.SEARCH_BY_COMPANY_DROPDOWN,
    label: "Search by company",
    key: "companyId",
  },
  {
    type: SearchFieldType.CHECKBOX,
    label: "Sandbox",
    key: "filter",
  },
];
